


































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Watch } from 'vue-property-decorator';
import RecaptchaComponent from '@/shared/captchaComponent/RecaptchaComponent.vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { PageTitleConfig } from '@/shared/msw-app-title/type';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import ApiServiceWrapper from '@/shared/api-request.service';
import jsEncrypt from '@/shared/jsEncrypt';

const STRENGTH_COLORS = ['#F00', '#F90', '#009940', '#009940'];
const cssPrefix = 'sw-reset-password';

@Component({
  components: {
    ...UUIFComponents,
    RecaptchaComponent,
    MswAppTitle,
    SwTextfield,
  },
})
export default class SwResetPassword extends SwExtendedVue {
  cssPrefix = cssPrefix;
  newPassword: string = '';
  confirmPassword: string = '';
  newPasswordError: string = '';
  captchaError: string = '';
  submitted: boolean = false;
  isSubmitted: boolean = false;
  isEntered: boolean = true;
  strength: string = '';
  bar0: string = '#DDD';
  bar1: string = '#DDD';
  bar2: string = '#DDD';
  bar3: string = '#DDD';
  tempToken: string = '';
  emailAddress: string = '';
  subscriptionCode: string = '';

  @Watch('newPassword')
  onNewPasswordChange(val: string) {
    this.newPasswordError = '';
    this.setBarColors(4, '#DDD');
    if (!val.trim()) {
      this.strength = '';
      return;
    }
    const lowerLetters = /.*?[a-z].*[a-z]/.test(val);
    const upperLetters = /.*?[A-Z].*[A-Z]/.test(val);
    const numbers = /.*?[0-9].*[0-9]/.test(val);
    const symbols = /.*?[$@/:-?{-~!"^_`[\]-].*[$@/:-?{-~!"^_`[\]-]/.test(val);
    const passedMatches = [lowerLetters, upperLetters, numbers, symbols].filter(Boolean).length;
    let idx = 0;
    this.strength = '';
    if (val.length >= 10 && passedMatches === 4) {
      idx = 3;
      this.strength = 'Strong';
    } else if (val.length >= 8 && passedMatches >= 2) {
      idx = 2;
      this.strength = 'Average';
    } else if (val.length >= 6 && passedMatches >= 1) {
      idx = 1;
      this.strength = 'Weak';
    } else {
      idx = 0;
      this.strength = 'Poor';
    }
    this.setBarColors(idx + 1, STRENGTH_COLORS[idx]);
  }

  setBarColors(count: number, col: string) {
    this.bar0 = '#DDD';
    this.bar1 = '#DDD';
    this.bar2 = '#DDD';
    this.bar3 = '#DDD';
    if (count > 0) { this.bar0 = col; }
    if (count > 1) { this.bar1 = col; }
    if (count > 2) { this.bar2 = col; }
    if (count > 3) { this.bar3 = col; }
  }

  created() {
    const query = (this as any).$route.query;
    const subscriptionCode = query.RC as string;
    const emailAddress = query.US as string;
    const tempToken = query.tempToken as string;

    if (!subscriptionCode || !emailAddress || !tempToken) {
      this.goBack();
      return;
    }

    this.subscriptionCode = subscriptionCode.trim();
    this.emailAddress = emailAddress.trim();
    this.tempToken = tempToken.trim().replace(/ /g, '+');
  }

  goBack() {
    this.$router.push({ path: '/m/login/login-view' });
  }

  private validatePassword(): boolean {
    this.newPasswordError = '';
    const pwd = this.newPassword.trim();
    const confirmPwd = this.confirmPassword.trim();
    let isValid = true;

    if (!pwd) {
      isValid = false;
    } else {
      const lowercaseCount = (pwd.match(/[a-z]/g) || []).length;
      const uppercaseCount = (pwd.match(/[A-Z]/g) || []).length;
      const symbolCount = (pwd.match(/[^a-zA-Z0-9]/g) || []).length;
      const numberCount = (pwd.match(/[0-9]/g) || []).length;
      const policyMet = pwd.length >= 8 && pwd.length <= 30
        && lowercaseCount >= 2 && uppercaseCount >= 2
        && symbolCount >= 1 && numberCount >= 2;
      if (!policyMet) {
        this.newPasswordError = this.$t('resetpassword.validationError1').toString();
        isValid = false;
      }
    }

    if (!confirmPwd || pwd !== confirmPwd) {
      isValid = false;
    }

    return isValid;
  }

  submit() {
    this.isSubmitted = true;
    this.captchaError = '';
    if (!this.validatePassword()) { return; }

    const captchaResult = (this.$refs.recaptchaRef as RecaptchaComponent).fetchCaptcha();
    if (captchaResult.status === 'error') {
      this.captchaError = this.$t('resetpassword.validationError3').toString();
      return;
    }

    const store = this.$store;
    const t = this.$t.bind(this);
    const escapeRecaptcha = window.btoa(`${this.emailAddress}#${new Date().toLocaleDateString().replace(/[^ -~]/g, '')}#${captchaResult.response}`);
    const fallbackMsg = t('login.forgotPasswordError').toString();
    store.commit('startLoading');
    ApiServiceWrapper.put('users/reset-password', {
      tempToken: this.tempToken,
      emailAddress: this.emailAddress,
      sourceName: escapeRecaptcha,
      subscriptionCode: this.subscriptionCode,
      password: jsEncrypt.getEncryptObj_msw().encrypt(this.newPassword.trim()),
      captchaText: captchaResult.response,
    })
      .then((res: any) => {
        store.commit('stopLoading');
        if (res != null && res.operationStatus === 'OK') {
          localStorage.removeItem('redirectarg1');
          localStorage.removeItem('redirectarg2');
          localStorage.removeItem('redirectarg3');
          this.submitted = true;
        } else {
          store.commit('enqueueMessage', { infoType: 'failed', infoMsg: (res != null ? res.msgDesc : null) || fallbackMsg });
        }
      })
      .catch((err: any) => {
        store.commit('stopLoading');
        const status = err && err.response && err.response.status;
        let errMsg: string;
        switch (status) {
          case 401: errMsg = this.$t('systemMessages.err401').toString(); break;
          case 404: errMsg = this.$t('systemMessages.err404').toString(); break;
          case 408: errMsg = this.$t('systemMessages.err408').toString(); break;
          default:  errMsg = this.$t('systemMessages.server').toString(); break;
        }
        store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errMsg });
      });
  }

  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('login.resetPasswordTitle').toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: false,
      isShowSlash: false,
      isShowParent: false,
    };
  }
}
